import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import { AppMultiSelect, AppSingleSelect } from "@/layout/AppComponents";
import ReactDOMServer from "react-dom/server";
import Translator from "../../helpers/Translator";
import { axiosPath } from "../../../../routing/helpers/router";
import errorHandler from "@/layout/components/error/ErrorHandler";
import useIsMounted from "../../hooks/useIsMounted";

export default function TotalEnergiesRiskProcessSelect({
  value,
  error,
  title,
  onHandleChange,
  className = "",
  isMulti = false,
  hasSearchBox = false,
  hasSelectOptions = false,
  isClearable = false,
  required = false,
  isDisabled = false,
  onlyParents = false,
  filterID = null,
}) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [processes, setProcesses] = useState();

  // > LOAD PROCESSES //
  const loadProcesses = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            onlyParents
              ? "api_r_user_module_totalEnergiesRisk_getProcesses"
              : "api_r_user_module_totalEnergiesRisk_getSubProcesses"
          ),
          { moduleBridgeHex, onlyParents }
        )
        .then(({ data }) => {
          if (isMounted.current) setProcesses(data);
        })
        .catch((e) => dispatch(errorHandler(e))),

    [moduleBridgeHex, onlyParents]
  );

  useEffect(() => {
    loadProcesses();
  }, []);
  // < LOAD PROCESSES //

  return isMulti ? (
    <AppMultiSelect
      options={
        filterID ? processes?.filter((p) => p.value !== filterID) : processes
      }
      title={title || "Procesos"}
      placeholder="Selecciona uno o varios procesos"
      value={value}
      onChange={onHandleChange}
      error={error}
      allowSelectAll
      className={className}
      isLoading={!processes}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
      required={required}
      isDisabled={isDisabled}
    />
  ) : (
    <AppSingleSelect
      options={
        filterID ? processes?.filter((p) => p.value !== filterID) : processes
      }
      title={title || "Proceso"}
      placeholder="Selecciona un proceso"
      value={value}
      onChange={onHandleChange}
      isLoading={!processes}
      error={error}
      hasSearchBox
      hasSelectOptions={hasSelectOptions}
      isClearable={isClearable}
      required={required}
      isDisabled={isDisabled}
    />
  );
}
